import {Space} from "antd";
import {LiveEventCoverImagesFormFieldsProps} from "./types";
import {NewOfferingCoverImagesUpload} from "../../general/cover-images";

export function LiveEventCoverImagesFormFields({
  accordionIndex,
  defaultCoverImages,
  deleteCoverImage,
  isDeleteLoading,
  isUploadLoading,
  offeringId,
  uploadCoverImages,
}: LiveEventCoverImagesFormFieldsProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <NewOfferingCoverImagesUpload
        defaultCoverImages={defaultCoverImages}
        deleteCoverImage={deleteCoverImage}
        isDeleteLoading={isDeleteLoading}
        isUploadLoading={isUploadLoading}
        offeringId={offeringId}
        uploadCoverImages={uploadCoverImages}
        offeringType="live-class"
      />
    </Space>
  );
}
